// React packages
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
// App
import App from "./components/app";
import { mainReducer } from "./reducers";
// SW
import registerServiceWorker from "./registerServiceWorker";
// CSS
import "semantic-ui-css/semantic.min.css";
import "rc-slider/dist/rc-slider.min.css";
import "./main.css";

// eslint-disable-next-line
Number.prototype.formatMoney = function() {
    var n = Math.round(this);
    var c = 0;
    var s = n < 0 ? "-" : "";
    // eslint-disable-next-line
    var i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))));
    // eslint-disable-next-line
    var j = (j = i.length) > 3 ? j % 3 : 0;
    // eslint-disable-next-line
    return (
        s +
        (j ? i.substr(0, j) + " " : "") +
        //eslint-disable-next-line
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + " ") +
        (c
            ? "," +
              Math.abs(n - i)
                  .toFixed(c)
                  .slice(2)
            : "")
    );
};

let store = createStore(mainReducer, composeWithDevTools());

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js